import { Component, OnInit } from '@angular/core';
import { TacheService } from '../../services/tache.service';
import { ActivatedRoute } from '@angular/router';
import { Tache } from '../../models/tache.model';

@Component({
  selector: 'ngx-app-salle',
  templateUrl: './salle.component.html',
  styleUrls: ['./salle.component.scss']
})
export class SalleComponent implements OnInit {

  tacheSalle: Tache[];
  constructor(private tacheService: TacheService,private route: ActivatedRoute) { 
      console.log(this.route.snapshot.queryParams.id);
      this.tacheService.get_tachesBySalle(this.route.snapshot.queryParams.id).subscribe((res: Tache[]) => {
        this.tacheSalle = res;
      });
  }

  ngOnInit() {
  }

}
